/* Spring Bars Finder
   Logica client-side. Tutti i dati specifici (reference, anni, lug, diametri) vivono in
   3 JSON statici esterni o in Algolia. Niente specifiche hardcoded in questo file. */

(function () {
  'use strict';

  var cfg = window.__SPRING_BARS_CONFIG__;
  if (!cfg) return;

  // Brands that use the special serial-decode flow (family + reference dropdown + serial input).
  // Easy to extend: just add lowercase brand names.
  var BRANDS_WITH_SERIAL_FLOW = ['rolex'];
  function isSerialFlowBrand(name) {
    return BRANDS_WITH_SERIAL_FLOW.indexOf((name || '').toLowerCase()) !== -1;
  }

  var t = cfg.i18n || {};
  function tr(key, fallback) {
    return Object.prototype.hasOwnProperty.call(t, key) ? t[key] : (fallback || key);
  }

  // ────────────────────────────────────────────────
  // DOM refs
  // ────────────────────────────────────────────────
  var root = document.querySelector('[data-spring-bars-finder]');
  if (!root) return;
  var $ = function (sel) { return root.querySelector(sel); };

  var brandInput = $('[data-sb-brand-input]');
  var brandResults = $('[data-sb-brand-results]');
  var brandSelected = $('[data-sb-brand-selected]');

  var rolexPanel = $('[data-sb-rolex-panel]');
  var familySelect = $('[data-sb-family]');
  var refSelect = $('[data-sb-rolex-reference]');
  var serialInput = $('[data-sb-serial]');

  var genericPanel = $('[data-sb-generic-panel]');
  var genericRef = $('[data-sb-generic-reference]');

  var submitBtn = $('[data-sb-submit]');
  var resetBtn = $('[data-sb-reset]');

  var resultEl = $('[data-sb-result]');
  var errorEl = $('[data-sb-error]');

  // Scelta guidata (2026-07-30): famiglia → versione, costruite dal mapping
  var guidedPanel = $('[data-sb-guided]');
  var precisePanel = $('[data-sb-precise]');
  var gFamily = $('[data-sb-g-family]');
  var gVariant = $('[data-sb-g-variant]');
  var modeToggle = $('[data-sb-mode-toggle]');

  var state = {
    brand: null,
    brandsCache: null,
    rolexData: null,
    serialRanges: null,
    families: null,
    productMapping: null,
    initialized: false
  };

  function clearSelect(sel, keepFirst) {
    var start = keepFirst ? 1 : 0;
    while (sel.options.length > start) sel.remove(start);
  }

  // ────────────────────────────────────────────────
  // Data loading
  // ────────────────────────────────────────────────
  function loadJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r.json();
    });
  }

  function loadRolexData() {
    if (state.rolexData) return Promise.resolve();
    return Promise.all([
      loadJson(cfg.urls.rolexReferences),
      loadJson(cfg.urls.rolexSerialRanges),
      loadJson(cfg.urls.modelToReferences)
    ]).then(function (arr) {
      state.rolexData = arr[0];
      state.serialRanges = arr[1];
      state.families = arr[2].families || [];
    });
  }

  function loadProductMapping() {
    if (state.productMapping) return Promise.resolve(state.productMapping);
    if (!cfg.urls || !cfg.urls.productMapping) return Promise.resolve(null);
    return loadJson(cfg.urls.productMapping).then(function (j) {
      state.productMapping = j;
      return j;
    }).catch(function () {
      state.productMapping = null;
      return null;
    });
  }

  // Pin diameter inference dalla family Algolia
  // (ricerca tecnica 2026-05-29: sport/pro + heavy precious → fat 2.0, dress steel → standard 1.5)
  function inferPinDiameter(family) {
    if (!family) return 1.5;
    var f = String(family).toLowerCase();
    if (/submariner|sea-dweller|daytona|gmt-master|yacht-master|sky-dweller|day-date ii|day-date 40/.test(f)) return 2.0;
    if (/pearlmaster/.test(f)) return 1.8;
    return 1.5;
  }

  function resolveProduct(specs) {
    // specs: { family?, lug, drilled?, brand?, pin? }
    var m = state.productMapping;
    if (!m || !m.mapping_index) return null;
    var idx = m.mapping_index;

    var pin = specs.pin != null ? specs.pin : inferPinDiameter(specs.family);
    var drilled = specs.drilled === true ? 'drilled' : specs.drilled === false ? 'blind' : null;
    var brand = (specs.brand || 'rolex').toLowerCase();

    // Tier 1: family|lug|drilled|pin (most specific, v2 schema)
    if (specs.family && specs.lug != null && drilled && idx.by_family_lug_drilled_pin) {
      var k1 = specs.family + '|' + specs.lug + '|' + drilled + '|' + pin;
      if (idx.by_family_lug_drilled_pin[k1]) {
        return findProduct(idx.by_family_lug_drilled_pin[k1][0]);
      }
    }

    // Tier 2: family|lug|pin (ignore drilled)
    if (specs.family && specs.lug != null && idx.by_family_lug_pin) {
      var k2 = specs.family + '|' + specs.lug + '|' + pin;
      if (idx.by_family_lug_pin[k2]) {
        return findProduct(idx.by_family_lug_pin[k2][0]);
      }
    }

    // Tier 3: family|lug (ignore drilled+pin)
    if (specs.family && specs.lug != null && idx.by_family_lug) {
      var k3 = specs.family + '|' + specs.lug;
      if (idx.by_family_lug[k3]) {
        return findProduct(idx.by_family_lug[k3][0]);
      }
    }

    // Tier 4: lug|brand (generic by lug width)
    if (specs.lug != null && idx.by_lug_brand) {
      var k4 = specs.lug + '|' + brand;
      if (idx.by_lug_brand[k4]) {
        return findProduct(idx.by_lug_brand[k4][0]);
      }
    }

    // Legacy fallbacks (per compat con mapping vecchio se ancora presente)
    if (specs.reference && idx.by_reference && idx.by_reference[specs.reference]) {
      return findProduct(idx.by_reference[specs.reference][0]);
    }
    if (specs.lug != null && idx.fallback_by_lug && idx.fallback_by_lug[specs.lug]) {
      return findProduct(idx.fallback_by_lug[specs.lug]);
    }

    return null;
  }

  function findProduct(handle) {
    var m = state.productMapping;
    if (!m || !m.products) return null;
    return m.products.find(function (p) { return p.handle === handle; }) || null;
  }

  function algoliaQuery(body) {
    return fetch(cfg.algolia.host + '/1/indexes/' + cfg.algolia.index + '/query', {
      method: 'POST',
      headers: {
        'X-Algolia-Application-Id': cfg.algolia.appId,
        'X-Algolia-API-Key': cfg.algolia.apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getBrandsFallback() {
    return (cfg.brandsFallback || []).map(function (b) {
      return { name: b.name, count: b.count };
    });
  }

  function loadBrandsList() {
    if (state.brandsCache) return Promise.resolve(state.brandsCache);
    return algoliaQuery({
      query: '',
      hitsPerPage: 0,
      facets: ['brand'],
      maxValuesPerFacet: 200
    }).then(function (data) {
      if (data && data.status === 403) {
        state.brandsCache = getBrandsFallback();
        return state.brandsCache;
      }
      var entries = Object.entries(data && data.facets && data.facets.brand || {});
      if (entries.length === 0) {
        state.brandsCache = getBrandsFallback();
        return state.brandsCache;
      }
      entries.sort(function (a, b) { return b[1] - a[1]; });
      state.brandsCache = entries.map(function (e) {
        return { name: e[0], count: e[1] };
      });
      return state.brandsCache;
    }).catch(function () {
      state.brandsCache = getBrandsFallback();
      return state.brandsCache;
    });
  }

  // ────────────────────────────────────────────────
  // Brand autocomplete
  // ────────────────────────────────────────────────
  function clearBrandResults() {
    while (brandResults.firstChild) brandResults.removeChild(brandResults.firstChild);
    brandResults.hidden = true;
  }

  function renderBrandResults(matches) {
    clearBrandResults();
    if (!matches.length) {
      brandResults.hidden = true;
      return;
    }
    matches.slice(0, 12).forEach(function (b) {
      var item = document.createElement('div');
      item.className = 'ms-sb-finder__brand-item';
      item.setAttribute('role', 'option');
      item.dataset.brand = b.name;
      var nm = document.createElement('span');
      nm.textContent = b.name;
      item.appendChild(nm);
      var sm = document.createElement('small');
      sm.textContent = b.count + ' ref.';
      item.appendChild(sm);
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        selectBrand(b.name);
      });
      brandResults.appendChild(item);
    });
    brandResults.hidden = false;
  }

  function selectBrand(name) {
    state.brand = name;
    brandInput.value = name;
    brandSelected.textContent = name;
    clearBrandResults();

    var isRolex = isSerialFlowBrand(name);
    rolexPanel.hidden = !isRolex;
    genericPanel.hidden = isRolex;

    if (isRolex) {
      loadRolexData().then(populateFamilies).catch(function (e) {
        showError(tr('error_data_load', 'Errore nel caricare i dati: ') + e.message);
      });
    }
    hideResult();
  }

  function handleBrandInput() {
    var q = brandInput.value.trim().toLowerCase();
    if (!q) {
      clearBrandResults();
      return;
    }
    loadBrandsList().then(function (brands) {
      var matches = brands.filter(function (b) {
        return b.name.toLowerCase().indexOf(q) !== -1;
      });
      renderBrandResults(matches);
    }).catch(function () {
      brandResults.hidden = true;
    });
  }

  function handleBrandFocus() {
    if (state.brand) return;
    loadBrandsList().then(function (brands) {
      renderBrandResults(brands.slice(0, 20));
    });
  }

  // ────────────────────────────────────────────────
  // Rolex flow — populate families and references
  // ────────────────────────────────────────────────
  function populateFamilies() {
    clearSelect(familySelect, true);
    var families = state.families.slice().sort(function (a, b) {
      return (a.display_order || 99) - (b.display_order || 99);
    });
    families.forEach(function (f) {
      var opt = document.createElement('option');
      opt.value = f.slug;
      opt.textContent = f.name;
      familySelect.appendChild(opt);
    });
  }

  function populateReferencesForFamily(familySlug) {
    clearSelect(refSelect, true);
    var fam = state.families.find(function (f) { return f.slug === familySlug; });
    if (!fam) return;
    (fam.references || []).forEach(function (r) {
      var opt = document.createElement('option');
      opt.value = r.reference;
      var yr = r.production_years || [];
      var yrLabel = yr[0] ? (' (' + yr[0] + (yr[1] ? '–' + yr[1] : '–oggi') + ')') : '';
      opt.textContent = r.reference + ' — ' + (r.model_name || '') + yrLabel;
      refSelect.appendChild(opt);
    });
  }

  // ────────────────────────────────────────────────
  // Rolex serial decoder
  // ────────────────────────────────────────────────
  function decodeRolexSerial(serial) {
    if (!serial) return null;
    var s = serial.trim().toUpperCase();
    if (!s) return null;

    if (/^[A-Z][0-9]{6}$/.test(s)) {
      var letter = s.charAt(0);
      var match = state.serialRanges.letter_prefix_era.ranges.find(function (r) {
        return r.prefix === letter;
      });
      if (match) {
        return {
          era: 'letter_prefix',
          year_start: match.year_start,
          year_end: match.year_end,
          confidence: match.confidence || 'high'
        };
      }
      return { era: 'letter_prefix', unknown_prefix: true };
    }

    if (/^[A-Z0-9]{8}$/.test(s)) {
      return {
        era: 'scrambled',
        year_start: state.serialRanges.scrambled_era.year_start,
        year_end: state.serialRanges.scrambled_era.year_end,
        scrambled: true
      };
    }

    if (/^[0-9]{4,8}$/.test(s)) {
      var n = parseInt(s, 10);
      var seq = state.serialRanges.sequential_era.ranges;
      var year = null;
      for (var i = 0; i < seq.length; i++) {
        if (n >= seq[i].serial_start) year = seq[i].year;
        else break;
      }
      if (year != null) {
        return { era: 'sequential', year_start: year, year_end: year + 1, confidence: 'medium' };
      }
      return { era: 'sequential', out_of_range: true };
    }

    return null;
  }

  function narrowReferenceByYear(familySlug, yearRange) {
    var fam = state.families.find(function (f) { return f.slug === familySlug; });
    if (!fam) return [];
    return (fam.references || []).filter(function (r) {
      var py = r.production_years || [];
      var start = py[0], end = py[1] == null ? 9999 : py[1];
      if (start == null) return true;
      return yearRange.year_start <= end && yearRange.year_end >= start;
    });
  }

  function lookupReferenceDetails(refStr) {
    if (!refStr) return null;
    var list = (state.rolexData && state.rolexData.references) || [];
    return list.find(function (r) { return String(r.reference) === String(refStr); }) || null;
  }

  // ────────────────────────────────────────────────
  // Submit + result rendering
  // ────────────────────────────────────────────────
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function hideError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function hideResult() {
    resultEl.hidden = true;
    while (resultEl.firstChild) resultEl.removeChild(resultEl.firstChild);
  }

  function emitMatch(payload) {
    try {
      window.dispatchEvent(new CustomEvent('sb:match', { detail: payload }));
    } catch (e) {}
  }

  function buildResult(opts) {
    hideResult();
    var box = document.createElement('div');

    var title = document.createElement('h3');
    title.className = 'ms-sb-finder__result-title';
    title.textContent = opts.title;
    box.appendChild(title);

    var dl = document.createElement('dl');
    dl.className = 'ms-sb-finder__specs';
    opts.specs.forEach(function (sp) {
      var dt = document.createElement('dt');
      dt.textContent = sp.label;
      var dd = document.createElement('dd');
      dd.textContent = sp.value;
      dl.appendChild(dt);
      dl.appendChild(dd);
    });
    box.appendChild(dl);

    if (opts.source) {
      var src = document.createElement('p');
      src.className = 'ms-sb-finder__source';
      src.textContent = tr('source_label', 'Fonte: ') + opts.source;
      box.appendChild(src);
    }

    if (opts.caveat) {
      var cv = document.createElement('p');
      cv.className = 'ms-sb-finder__caveat';
      cv.textContent = opts.caveat;
      box.appendChild(cv);
    }

    if (opts.product) {
      var card = document.createElement('div');
      card.className = 'ms-sb-finder__product';
      var pTitle = document.createElement('p');
      pTitle.className = 'ms-sb-finder__product-label';
      pTitle.textContent = tr('product_recommended', 'Prodotto consigliato');
      card.appendChild(pTitle);
      var pName = document.createElement('p');
      pName.className = 'ms-sb-finder__product-name';
      pName.textContent = opts.product.title;
      card.appendChild(pName);
      var pLink = document.createElement('a');
      pLink.className = 'ms-sb-finder__product-link';
      pLink.href = opts.product.url;
      pLink.target = '_blank';
      pLink.rel = 'noopener';
      pLink.textContent = tr('product_link', 'Vedi il prodotto →');
      card.appendChild(pLink);
      box.appendChild(card);
    }

    resultEl.appendChild(box);
    resultEl.hidden = false;
    resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function handleSubmit() {
    hideError();
    if (!state.brand) {
      showError(tr('error_no_brand', 'Scegli prima un brand.'));
      return;
    }

    if (isSerialFlowBrand(state.brand)) {
      submitRolex();
    } else {
      submitGeneric();
    }
  }

  function submitRolex() {
    var fam = familySelect.value;
    var directRef = refSelect.value;
    var serial = serialInput.value.trim();

    if (!fam) {
      showError(tr('error_no_family', 'Seleziona la famiglia del modello.'));
      return;
    }

    var refDetails = null;
    var yearLabel = '';

    if (directRef) {
      refDetails = lookupReferenceDetails(directRef);
      if (refDetails && refDetails.production_years) {
        var py = refDetails.production_years;
        yearLabel = py[0] + (py[1] ? '–' + py[1] : '–oggi');
      }
    } else if (serial) {
      var decoded = decodeRolexSerial(serial);
      if (!decoded) {
        showError(tr('error_bad_serial', 'Seriale non riconosciuto. Verifica i caratteri.'));
        return;
      }
      if (decoded.scrambled) {
        showError(tr('error_scrambled', 'Dal 2010 i seriali Rolex sono randomizzati. Inserisci la reference invece del seriale.'));
        return;
      }
      var candidates = narrowReferenceByYear(fam, decoded);
      if (!candidates.length) {
        showError(tr('error_no_match_year', 'Nessuna reference di questa famiglia attiva nel range anno indicato dal seriale.'));
        return;
      }
      refDetails = lookupReferenceDetails(candidates[0].reference);
      yearLabel = '~' + decoded.year_start + (decoded.year_end && decoded.year_end !== decoded.year_start ? '–' + decoded.year_end : '');
    } else {
      showError(tr('error_need_ref_or_serial', 'Inserisci la reference o il seriale.'));
      return;
    }

    if (!refDetails) {
      showError(tr('error_no_ref_details', 'Reference non presente nel mio elenco. Scrivimi in atelier per la misura esatta.'));
      return;
    }

    var specs = [];
    specs.push({ label: tr('spec_reference', 'Reference'), value: String(refDetails.reference) });
    if (refDetails.model_name) specs.push({ label: tr('spec_model', 'Modello'), value: refDetails.model_name });
    if (yearLabel) specs.push({ label: tr('spec_year', 'Anno indicativo'), value: yearLabel });
    if (refDetails.lug_width_mm != null) {
      specs.push({ label: tr('spec_lug_width', 'Lug width'), value: refDetails.lug_width_mm + ' mm' });
    }
    if (refDetails.spring_bar_diameter_mm != null) {
      specs.push({ label: tr('spec_diameter', 'Diametro spring bar'), value: refDetails.spring_bar_diameter_mm + ' mm' });
    }
    if (refDetails.drilled_lugs != null) {
      specs.push({ label: tr('spec_drilled', 'Anse forate'), value: refDetails.drilled_lugs ? tr('yes', 'sì') : tr('no', 'no') });
    }

    var caveat = refDetails.verified_by_antonio
      ? tr('caveat_verified', 'Dato verificato direttamente.')
      : tr('caveat_unverified', 'Misure da fonte specialistica, non da esemplare in mano. Sempre meglio confermare con il calibro.');

    loadProductMapping().then(function () {
      var product = resolveProduct({
        reference: refDetails.reference,
        family: refDetails.family_algolia || refDetails.model_family || null,
        lug: refDetails.lug_width_mm,
        diameter: refDetails.spring_bar_diameter_mm,
        drilled: refDetails.drilled_lugs,
        brand: 'rolex'
      });
      buildResult({
        title: state.brand + ' — ' + (refDetails.model_family || ''),
        specs: specs,
        source: refDetails.sources ? refDetails.sources.join(', ') : null,
        caveat: caveat,
        product: product
      });
      emitMatch({
        brand: 'Rolex',
        currentReference: refDetails.reference,
        product: product,
        specs: { lug: refDetails.lug_width_mm, diameter: refDetails.spring_bar_diameter_mm, drilled: refDetails.drilled_lugs }
      });
    });
  }

  function submitGeneric() {
    var refQuery = (genericRef.value || '').trim();
    if (!refQuery) {
      showError(tr('error_no_reference', 'Inserisci la reference dell\'orologio.'));
      return;
    }

    algoliaQuery({
      query: refQuery,
      filters: 'brand:"' + state.brand.replace(/"/g, '\\"') + '"',
      hitsPerPage: 5,
      attributesToRetrieve: [
        'brand', 'reference', 'name', 'family',
        'lug_width', 'drilled_lugs',
        'lug_width_source', 'lug_width_source_url', 'lug_width_confidence'
      ]
    }).then(function (data) {
      if (data && data.status === 403) {
        showError(tr('error_search', 'Ricerca temporaneamente non disponibile. ') + tr('error_lug_unknown', 'Misurala col calibro o scrivimi.'));
        return;
      }
      var hits = data && data.hits || [];
      var hit = hits.find(function (h) { return String(h.reference || '').toLowerCase() === refQuery.toLowerCase(); }) || hits[0];
      if (!hit) {
        showError(tr('error_no_algolia_match', 'Reference non trovata per questo brand. Verifica oppure scrivimi.'));
        return;
      }
      if (hit.lug_width == null || hit.lug_width === 0) {
        showError(tr('error_lug_unknown', 'Lug width non disponibile per questa reference. Misurala col calibro o scrivimi.'));
        return;
      }

      var specs = [];
      specs.push({ label: tr('spec_reference', 'Reference'), value: String(hit.reference) });
      if (hit.name) specs.push({ label: tr('spec_model', 'Modello'), value: hit.name });
      if (hit.family) specs.push({ label: tr('spec_family', 'Famiglia'), value: hit.family });
      specs.push({ label: tr('spec_lug_width', 'Lug width'), value: hit.lug_width + ' mm' });

      loadProductMapping().then(function () {
        var product = resolveProduct({
          reference: String(hit.reference),
          family: hit.family || null,
          lug: hit.lug_width,
          drilled: hit.drilled_lugs == null ? null : !!hit.drilled_lugs,
          brand: (hit.brand || state.brand).toLowerCase()
        });
        buildResult({
          title: state.brand + ' ' + hit.reference,
          specs: specs,
          source: hit.lug_width_source || null,
          caveat: tr('caveat_generic', 'Per il diametro della spring bar e la presenza di fori sulle anse, controlla la scheda tecnica del produttore o passa in atelier.'),
          product: product
        });
        emitMatch({
          brand: hit.brand || state.brand,
          currentReference: String(hit.reference),
          product: product,
          specs: { lug: hit.lug_width, diameter: null, drilled: null }
        });
      });
    }).catch(function (e) {
      showError(tr('error_search', 'Errore nella ricerca: ') + e.message);
    });
  }

  // ────────────────────────────────────────────────
  // Scelta guidata: famiglia → versione (dal mapping prodotti)
  // Stessa filosofia del finder .com: due menu, zero digitazione.
  // La ricerca per referenza resta come percorso "preciso" dietro il toggle.
  // ────────────────────────────────────────────────
  function brandFromHandle(handle) {
    var m = /^spring-bars-([a-z]+)/.exec(handle || '');
    var b = m ? m[1] : '';
    return (b === 'universal' || b === 'quick') ? '_universal' : b;
  }

  function titleCase(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function variantLabel(p) {
    var base = String(p.title || p.handle).replace(/^spring\s*bars\s*/i, '');
    // Stile .com (2026-07-31, richiesta Antonio): la voce del menu mostra LE
    // REFERENZE — "16613", "1500 / 1501 / 15010…" — così il cliente riconosce
    // il suo orologio e clicca. Qualifica breve in coda (misura, oro, forate).
    if (p.finder_refs && p.finder_refs.length) {
      var refs = p.finder_refs.join(' / ') + (p.finder_refs_more ? ' …' : '');
      var q = [];
      var t = base.toLowerCase();
      var mm = (base.match(/(\d{2})\s*mm/) || [])[1];
      if (mm) q.push(mm + 'mm');
      if (/vintage/.test(t)) q.push('vintage');
      if (/forate/.test(t)) q.push('anse forate');
      if (/\boro\b|gold/.test(t)) q.push('oro');
      if (/set|multi/.test(t)) q.push('set');
      return refs + (q.length ? ' — ' + q.join(', ') : '');
    }
    return base;
  }

  function buildGuidedGroups() {
    var bf = (cfg.brandFilter || '').trim().toLowerCase();
    var groups = {};

    // ROLEX: tabella curata a mano, replica esatta del finder .com
    // (assets/spring-bars-fitment-curated.json: famiglia → riga con le
    // referenze scritte dentro → prodotto). Richiesta Antonio 2026-07-31.
    var fit = state.fitmentCurated;
    var curatedRolex = fit && fit.rows && fit.rows.length;
    if (curatedRolex && (!bf || bf === 'rolex')) {
      fit.rows.forEach(function (row) {
        if (!findProduct(row.handle)) return;
        var key = 'rolex|' + row.family;
        var label = bf ? row.family : ('Rolex — ' + row.family);
        if (!groups[key]) groups[key] = { label: label, rows: [] };
        groups[key].rows.push(row);
      });
    }

    // OMEGA / TUDOR / UNIVERSALI (e fallback Rolex se la tabella non carica):
    // dai prodotti del mapping
    var m = state.productMapping;
    if (m && m.products) {
      m.products.forEach(function (p) {
        if (p.status && p.status !== 'ACTIVE') return;
        if (p.published === false) return;
        var pb = brandFromHandle(p.handle);
        if (pb === 'rolex' && curatedRolex) return; // rolex già coperto dalla tabella curata
        if (bf && pb !== bf && pb !== '_universal') return;
        var key, label;
        if (pb === '_universal') {
          key = '_universal';
          label = tr('universal_group', 'Set universali e multi-misura');
        } else if (!p.family_algolia) {
          // prodotti di brand per-misura (es. "Omega 20mm"): gruppo = brand
          key = pb + '|_brand';
          label = titleCase(pb);
        } else {
          key = pb + '|' + p.family_algolia;
          label = bf ? p.family_algolia : (titleCase(pb) + ' — ' + p.family_algolia);
        }
        if (!groups[key]) groups[key] = { label: label, products: [] };
        groups[key].products.push(p);
      });
    }
    return Object.keys(groups).length ? groups : null;
  }

  function initGuided() {
    if (!guidedPanel || !precisePanel || !gFamily || !gVariant || !modeToggle) return;
    var groups = buildGuidedGroups();
    if (!groups || Object.keys(groups).length === 0) return; // niente mapping → resta il percorso preciso
    state.guidedGroups = groups;

    var keys = Object.keys(groups).filter(function (k) { return k !== '_universal'; })
      .sort(function (a, b) { return groups[a].label.localeCompare(groups[b].label); });
    if (groups['_universal']) keys.push('_universal');

    clearSelect(gFamily, true);
    keys.forEach(function (k) {
      var opt = document.createElement('option');
      opt.value = k;
      opt.textContent = groups[k].label;
      gFamily.appendChild(opt);
    });

    setGuidedMode(true);
    modeToggle.hidden = false;
  }

  function populateGuidedVariants(key) {
    clearSelect(gVariant, true);
    var g = state.guidedGroups && state.guidedGroups[key];
    gVariant.disabled = !g;
    if (!g) return;

    // tabella curata (stile .com): etichette verbatim, nell'ordine curato
    if (g.rows) {
      g.rows.forEach(function (row) {
        var opt = document.createElement('option');
        opt.value = row.handle;
        opt.textContent = row.label;
        gVariant.appendChild(opt);
      });
      if (g.rows.length === 1) {
        gVariant.value = g.rows[0].handle;
        showGuidedResult(g.rows[0].handle);
      }
      return;
    }

    var prods = g.products.slice().sort(function (a, b) {
      return variantLabel(a).localeCompare(variantLabel(b));
    });
    prods.forEach(function (p) {
      var opt = document.createElement('option');
      opt.value = p.handle;
      opt.textContent = variantLabel(p);
      gVariant.appendChild(opt);
    });
    // una sola versione: risultato immediato, niente terza scelta inutile
    if (prods.length === 1) {
      gVariant.value = prods[0].handle;
      showGuidedResult(prods[0].handle);
    }
  }

  function showGuidedResult(handle) {
    var p = findProduct(handle);
    if (!p) return;
    hideError();
    var specs = [];
    var lug = p.lug_width_mm != null ? p.lug_width_mm : p.lug;
    var pin = p.spring_bar_diameter_mm != null ? p.spring_bar_diameter_mm : p.pin_diameter;
    if (lug != null) specs.push({ label: tr('spec_lug_width', 'Lug width'), value: lug + ' mm' });
    if (pin != null) specs.push({ label: tr('spec_diameter', 'Diametro spring bar'), value: pin + ' mm' });
    if (p.drilled_lugs === true || p.drilled_lugs === false) {
      specs.push({ label: tr('spec_drilled', 'Anse forate'), value: p.drilled_lugs ? tr('yes', 'sì') : tr('no', 'no') });
    }
    buildResult({
      title: p.title,
      specs: specs,
      product: { title: p.title, url: p.url || ('/products/' + p.handle) }
    });
    emitMatch({
      brand: state.brand || cfg.brandFilter || null,
      currentReference: null,
      product: p,
      specs: { lug: lug, diameter: pin, drilled: p.drilled_lugs == null ? null : !!p.drilled_lugs }
    });
  }

  function setGuidedMode(on) {
    state.guidedMode = on;
    guidedPanel.hidden = !on;
    precisePanel.hidden = on;
    modeToggle.textContent = on
      ? (modeToggle.getAttribute('data-label-precise') || '')
      : (modeToggle.getAttribute('data-label-guided') || '');
    hideError();
    hideResult();
  }

  function handleReset() {
    state.brand = null;
    brandInput.value = '';
    brandSelected.textContent = '';
    clearBrandResults();
    rolexPanel.hidden = true;
    genericPanel.hidden = true;
    familySelect.value = '';
    clearSelect(refSelect, true);
    serialInput.value = '';
    genericRef.value = '';
    hideError();
    hideResult();
    try { window.dispatchEvent(new CustomEvent('sb:reset')); } catch (e) {}
    brandInput.focus();
  }

  // ────────────────────────────────────────────────
  // Wire up
  // ────────────────────────────────────────────────
  brandInput.addEventListener('input', handleBrandInput);
  brandInput.addEventListener('focus', handleBrandFocus);
  brandInput.addEventListener('blur', function () { setTimeout(function () { brandResults.hidden = true; }, 150); });
  familySelect.addEventListener('change', function () { populateReferencesForFamily(familySelect.value); });
  submitBtn.addEventListener('click', handleSubmit);
  resetBtn.addEventListener('click', handleReset);

  if (gFamily) gFamily.addEventListener('change', function () { hideResult(); hideError(); populateGuidedVariants(gFamily.value); });
  if (gVariant) gVariant.addEventListener('change', function () { if (gVariant.value) showGuidedResult(gVariant.value); });
  if (modeToggle) modeToggle.addEventListener('click', function () { setGuidedMode(!state.guidedMode); });

  // la cascata guidata parte appena mapping + tabella curata sono disponibili
  Promise.all([
    loadProductMapping(),
    cfg.urls && cfg.urls.fitmentCurated
      ? loadJson(cfg.urls.fitmentCurated).then(function (j) { state.fitmentCurated = j; }).catch(function () { state.fitmentCurated = null; })
      : Promise.resolve()
  ]).then(initGuided).catch(function () { /* resta il percorso preciso */ });

  // Brand filter pre-selection (per landing brand pages)
  if (cfg.brandFilter && typeof cfg.brandFilter === 'string' && cfg.brandFilter.trim()) {
    var bf = cfg.brandFilter.trim();
    // Title-case the filter (Rolex, Omega, etc.) — Algolia brand index uses title-case
    var bfTitled = bf.charAt(0).toUpperCase() + bf.slice(1);
    // Hide brand input UI for filtered landings
    if (brandInput) {
      var parent = brandInput.closest('.ms-sb-finder__field');
      if (parent) parent.style.display = 'none';
    }
    selectBrand(bfTitled);
  }

  state.initialized = true;
})();
